import { render } from "./AdminPaymentmethodCreate.vue?vue&type=template&id=774d14b6&scoped=true&ts=true&lang=true"
import script from "./AdminPaymentmethodCreate.vue?vue&type=script&lang=ts"
export * from "./AdminPaymentmethodCreate.vue?vue&type=script&lang=ts"

import "./AdminPaymentmethodCreate.vue?vue&type=style&index=0&id=774d14b6&scoped=true&lang=css"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-774d14b6"]])

export default __exports__